import { useQuery } from "@tanstack/react-query";
import { useApi } from "src/api";

export const storePlanogramReviewStorePogQueryKey = (storePogId: number) => [
  "store-planogram-review",
  "store-pog",
  storePogId,
];

export const useStorePlanogramReviewStorePogQuery = (
  storePogId: number,
  hasStorePogData: boolean,
) => {
  const { getMerchflowStorePogApi } = useApi();

  return useQuery({
    queryKey: storePlanogramReviewStorePogQueryKey(storePogId),
    queryFn: async () => {
      // No ranging: the popup never shows the ranged-in-other-stores counts, and working
      // them out reads every store pog in the flow, which is slow on a large flow.
      const response = await getMerchflowStorePogApi(storePogId, false);
      // Throw rather than cache the failure, so coming back to this store asks again.
      if (!response) throw new Error(`Store pog ${storePogId} did not load`);
      return response;
    },
    enabled: !hasStorePogData,
  });
};
